<script>
import { mapActions, mapGetters } from 'vuex';

import request from '@/services/request';
import Catalogue from '@/services/catalogue';
import Pagination from 'vue-pagination-2';
import ModalForm from '@/components/departments/ModalUserDepartamentComponent.vue';
import ModalTablePays from '@/components/departments/ModalTablePaysComponent.vue';
import ModalContractEnds from '@/components/contracts/ModalContractEndsComponent.vue';
import ModalFormCurrentPayments from '@/components/contracts/ModalFormCurrentPayments.vue';
import ModalTableContractsRelation from '@/components/contracts/ModalTableContractsRelationComponent.vue';

import ModalFormComponentContracts from '@/components/contracts_new/ModaFormComponent.vue';
import ModalFormIncreases from '@/components/contracts_new/ModaFormIncreasesComponent.vue';
import ModalFilesContractsComponent from '@/components/contracts_new/ModalFilesContractsComponent.vue';
import ModalContractEndsDetailComponent from '@/components/contracts/ModalContractEndsDetailComponent.vue';
import ModalContractBillingDay from '@/components/contracts/ModalContractBillingDay.vue';

const createDefaultSearch = () => ({
    search: '',
    building_id: '',
    company_id: '',
    status: 1,
    finish: '',
    user_id: '',
    month: '',
    year: '',
    department_id: '',
    authorization_user_id: '',
    authorization_status: '',
    user_id_authorization: '',
    payment_period_id: [1, 2, 3, 4, 5, 6, 7, 8, 9]
});

export default {
    name: 'contracts-table',

    components: {
        Pagination,
        ModalFormComponentContracts,
        ModalForm,
        ModalTablePays,
        ModalContractEnds,
        ModalFormCurrentPayments,
        ModalTableContractsRelation,
        ModalFormIncreases,
        ModalFilesContractsComponent,
        ModalContractEndsDetailComponent,
        ModalContractBillingDay
    },

    data() {
        const currentYear = new Date().getFullYear();

        return {
            editForm: false,
            load: false,
            loadCount: false,
            showFilters: true,
            catalogue: new Catalogue(),
            clientCatalogue: new Catalogue(),
            authorizationCatalogue: new Catalogue(),
            page: 1,
            searchTimer: null,
            reloadContractsHandler: null,
            expandedContracts: [],
            buys: {
                data: [],
                total: 0,
                per_page: 50
            },
            count1: 0,
            count2: 0,
            years: Array.from(
                { length: currentYear - 2019 + 4 },
                (value, index) => 2020 + index
            ),
            months: [
                { value: 1, label: 'Enero' },
                { value: 2, label: 'Febrero' },
                { value: 3, label: 'Marzo' },
                { value: 4, label: 'Abril' },
                { value: 5, label: 'Mayo' },
                { value: 6, label: 'Junio' },
                { value: 7, label: 'Julio' },
                { value: 8, label: 'Agosto' },
                { value: 9, label: 'Septiembre' },
                { value: 10, label: 'Octubre' },
                { value: 11, label: 'Noviembre' },
                { value: 12, label: 'Diciembre' }
            ],
            paymentPeriods: [
                { value: 1, label: 'Mensual' },
                { value: 2, label: 'Bimestral' },
                { value: 3, label: 'Semestral' },
                { value: 4, label: 'Anual' },
                { value: 5, label: 'Pago único' },
                { value: 6, label: 'Semanal' },
                { value: 7, label: 'Quincenal' },
                { value: 8, label: 'Trimestral' },
                { value: 9, label: 'Cuatrimestral' }
            ],
            search: createDefaultSearch(),
            billingModalVisible: false,
            billingContractId: null,
        };
    },

    computed: {
        ...mapGetters({
            authUser: 'auth/user'
        }),

        contracts() {
            return this.buys && Array.isArray(this.buys.data)
                ? this.buys.data
                : [];
        },

        canFilterAuthorization() {
            if (!this.authUser) {
                return false;
            }

            return [1, 10, 11].includes(
                Number(this.authUser.organization_charts_id)
            );
        },

        canSelectAuthorizationUser() {
            return [1, 10, 11].includes(
                Number(this.search.authorization_user_id)
            );
        },

        activeFiltersCount() {
            return Object.keys(this.search).filter(key => {
                const value = this.search[key];

                if (key === 'status') {
                    return Number(value) !== 1;
                }

                if (key === 'payment_period_id') {
                    return !Array.isArray(value) || value.length !== 9;
                }

                if (Array.isArray(value)) {
                    return value.length > 0;
                }

                return value !== '' && value !== null;
            }).length;
        },

        pageContractsWithIncreases() {
            return this.contracts.filter(
                contract => contract.has_applied_increases
            ).length;
        },

        pageUnsignedContracts() {
            return this.contracts.filter(
                contract => Number(contract.signed) === 0
            ).length;
        },

        pageExpiredContracts() {
            return this.contracts.filter(
                contract =>
                    this.isExpiredDate(contract.end_date) &&
                    !contract.end_all
            ).length;
        },

        pagePendingAuthorizations() {
            return this.contracts.filter(
                contract => !this.isFullyAuthorized(contract)
            ).length;
        }
    },

    watch: {
        search: {
            deep: true,
            handler() {
                window.clearTimeout(this.searchTimer);

                this.searchTimer = window.setTimeout(() => {
                    this.page = 1;
                    this.list(1);
                }, 300);
            }
        }
    },

    created() {
        this.reloadContractsHandler = () => {
            this.list(this.page);
        };

        Event.$on('event-load-contracts', this.reloadContractsHandler);
    },

    mounted() {
        this.list();
        this.catalogue.get_buildings();
        this.catalogue.get_companies_all();
        this.clientCatalogue.get_users_profile(7);
    },

    beforeDestroy() {
        window.clearTimeout(this.searchTimer);

        if (this.reloadContractsHandler) {
            Event.$off(
                'event-load-contracts',
                this.reloadContractsHandler
            );
        }
    },

    methods: {
        showBillingModal(contract) {
            if (!contract || !contract.id) {
                return;
            }

            this.billingContractId = contract.id;
            this.billingModalVisible = true;
        },

        closeBillingModal() {
            this.billingModalVisible = false;
            this.billingContractId = null;
        },

        onBillingScheduleUpdated() {
            this.list(this.page);
        },
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success'
        }),

        confirmCancelAuthorization(contract, authorization) {

            this.$swal({
                title: '¿Cancelar autorización?',
                html: `
            Se eliminará la autorización de
            <strong>${authorization.label}</strong>.
            <br><br>
            Esta acción dejará nuevamente la autorización como pendiente.
        `,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, cancelar autorización',
                cancelButtonText: 'Conservar',
                confirmButtonColor: '#dc2626',
                reverseButtons: true
            }).then((result) => {

                if (!result.isConfirmed) {
                    return;
                }

                this.cancelAuthorization(contract, authorization);
            });
        },

        async cancelAuthorization(contract, authorization) {

            console.log(contract);
            console.log(authorization);
            try {

                await request.post(
                    `/contracts/${contract.id}/cancel-authorization`,
                    {
                        user_id: authorization.user_id
                    }
                );

                this.$swal({
                    icon: 'success',
                    title: 'Autorización cancelada',
                    text: 'La autorización quedó nuevamente pendiente.',
                    timer: 1800,
                    showConfirmButton: false
                });

                // Actualizar contrato
                this.list();

            } catch (error) {
                console.log(error);
                this.$swal({
                    icon: 'error',
                    title: 'No se pudo cancelar',
                    text: error.response?.data?.message ||
                        'Ocurrió un error al cancelar la autorización.'
                });

            }
        },

        getParentContractIds(contract) {
            if (!contract || !Array.isArray(contract.all_parent_ids)) {
                return [];
            }

            return contract.all_parent_ids;
        },

        hasParentContracts(contract) {
            return this.getParentContractIds(contract).length > 0;
        },

        parseBackendDate(date) {
            if (!date) {
                return null;
            }

            if (date instanceof Date) {
                return new Date(date.getTime());
            }

            const rawDate = String(date).trim();
            const dateOnlyMatch = rawDate.match(/^(\d{4})-(\d{2})-(\d{2})$/);

            if (dateOnlyMatch) {
                return new Date(
                    Number(dateOnlyMatch[1]),
                    Number(dateOnlyMatch[2]) - 1,
                    Number(dateOnlyMatch[3])
                );
            }

            const normalizedDate = rawDate.replace(' ', 'T');

            const parsedDate = new Date(normalizedDate);

            return Number.isNaN(parsedDate.getTime())
                ? null
                : parsedDate;
        },

        isExpiredDate(endDate) {
            const expirationDate = this.parseBackendDate(endDate);

            if (!expirationDate) {
                return false;
            }

            const today = new Date();

            expirationDate.setHours(23, 59, 59, 999);
            today.setHours(0, 0, 0, 0);

            return expirationDate < today;
        },

        toNumber(value) {
            const number = Number(value);
            return Number.isFinite(number) ? number : 0;
        },

        amountChanged(originalAmount, currentAmount) {
            return Math.abs(
                this.toNumber(currentAmount) -
                this.toNumber(originalAmount)
            ) >= 0.01;
        },

        currentAmount(item, currentKey, originalKey) {
            if (!item) {
                return 0;
            }

            const current = item[currentKey];

            return current !== undefined && current !== null
                ? this.toNumber(current)
                : this.toNumber(item[originalKey]);
        },

        getUniqueRentRecord(contract) {
            if (!contract || !contract.unique_rent_data) {
                return null;
            }

            return Array.isArray(contract.unique_rent_data)
                ? contract.unique_rent_data[0] || null
                : contract.unique_rent_data;
        },

        getContractRentTotal(contract) {
            if (Number(contract.unique_rent) === 1) {
                const rent = this.getUniqueRentRecord(contract);

                return this.currentAmount(
                    rent,
                    'current_subtotal',
                    'subtotal'
                );
            }

            return (contract.departments || []).reduce(
                (total, department) => total + this.currentAmount(
                    department,
                    'current_subtotal_rent',
                    'subtotal_rent'
                ),
                0
            );
        },

        getContractDepositOriginalTotal(contract) {
            if (!contract) {
                return 0;
            }

            if (Number(contract.unique_deposit) === 1) {
                return this.toNumber(contract.deposit_amount);
            }

            return (contract.departments || []).reduce(
                (total, department) =>
                    total + this.toNumber(department.deposit),
                0
            );
        },

        getContractDepositTotal(contract) {
            if (!contract) {
                return 0;
            }

            /*
             * El backend ya entrega el depósito vigente calculado con
             * los aumentos publicados.
             *
             * Depósito único:
             *   current_deposit_amount
             *
             * Depósito por indiviso:
             *   department.current_deposit
             */
            if (Number(contract.unique_deposit) === 1) {
                const currentDeposit = contract.current_deposit_amount;

                return currentDeposit !== undefined && currentDeposit !== null
                    ? this.toNumber(currentDeposit)
                    : this.toNumber(contract.deposit_amount);
            }

            return (contract.departments || []).reduce(
                (total, department) => total + this.currentAmount(
                    department,
                    'current_deposit',
                    'deposit'
                ),
                0
            );
        },

        getVisibleServices(contract) {
            const services = [];

            if (Number(contract.unique_services) === 1) {
                (contract.unique_services_data || []).forEach(service => {
                    if (
                        Number(service.include_rent) === 0 &&
                        this.toNumber(service.subtotal) > 0
                    ) {
                        services.push({
                            ...service,
                            department_label: null
                        });
                    }
                });

                return services;
            }

            (contract.departments || []).forEach(department => {
                (department.services || []).forEach(service => {
                    if (
                        Number(service.include_rent) === 0 &&
                        this.toNumber(service.subtotal) > 0
                    ) {
                        services.push({
                            ...service,
                            department_label:
                                `Piso ${department.level || '-'} / ` +
                                `${department.number || '-'}`
                        });
                    }
                });
            });

            return services;
        },

        getIncludedServices(contract) {
            const services = [];

            if (Number(contract.unique_services) === 1) {
                (contract.unique_services_data || []).forEach(service => {
                    if (
                        Number(service.include_rent) !== 0 &&
                        this.toNumber(service.subtotal) > 0
                    ) {
                        services.push({
                            ...service,
                            department_label: null
                        });
                    }
                });

                return services;
            }

            (contract.departments || []).forEach(department => {
                (department.services || []).forEach(service => {
                    if (
                        Number(service.include_rent) !== 0 &&
                        this.toNumber(service.subtotal) > 0
                    ) {
                        services.push({
                            ...service,
                            department_label:
                                `Piso ${department.level || '-'} / ` +
                                `${department.number || '-'}`
                        });
                    }
                });
            });

            return services;
        },

        getServicesTotal(contract) {
            return this.getVisibleServices(contract).reduce(
                (total, service) => total + this.currentAmount(
                    service,
                    'current_subtotal',
                    'subtotal'
                ),
                0
            );
        },

        getServiceName(service) {
            if (!service) {
                return 'Servicio';
            }

            if (service.service && service.service.name) {
                return service.service.name;
            }

            return service.name || service.service_name || 'Servicio';
        },

        getClientName(contract) {
            if (!contract || !contract.user) {
                return 'Cliente no asignado';
            }

            return [contract.user.name, contract.user.last_name]
                .filter(Boolean)
                .join(' ');
        },

        getClientInitials(contract) {
            if (!contract || !contract.user) {
                return '--';
            }

            return [contract.user.name, contract.user.last_name]
                .filter(Boolean)
                .map(value => String(value).trim().charAt(0))
                .join('')
                .substring(0, 2)
                .toUpperCase();
        },

        getContractStatus(contract) {
            if (contract.end_all) {
                return {
                    label: 'Finalizado',
                    className: 'contract-status--finished',
                    icon: 'fa-circle-check'
                };
            }

            if (this.isExpiredDate(contract.end_date)) {
                return {
                    label: 'Vencido',
                    className: 'contract-status--expired',
                    icon: 'fa-circle-exclamation'
                };
            }

            if (Number(contract.status) === 2) {
                return {
                    label: 'Terminado',
                    className: 'contract-status--finished',
                    icon: 'fa-circle-check'
                };
            }

            if (Number(contract.signed) === 0) {
                return {
                    label: 'Falta firma',
                    className: 'contract-status--pending',
                    icon: 'fa-file-signature'
                };
            }

            return {
                label: 'Activo',
                className: 'contract-status--active',
                icon: 'fa-circle'
            };
        },

        isFullyAuthorized(contract) {
            return this.getAuthorizationProgress(contract).completed === 3;
        },

        hasNoAuthorizations(contract) {
            return this.getAuthorizationProgress(contract).completed === 0;
        },

        getAuthorizationDefinitions() {
            return [
                {
                    key: 'user_admin',
                    label: 'Administración',
                    icon: 'fa-user-shield'
                },
                {
                    key: 'user_auxiliary',
                    label: 'Analista contable',
                    icon: 'fa-calculator'
                },
                {
                    key: 'user_juridical',
                    label: 'Jurídico',
                    icon: 'fa-scale-balanced'
                }
            ];
        },

        getAuthorizationUserName(authorization) {
            const user = authorization && authorization.user
                ? authorization.user
                : authorization;

            if (!user) {
                return 'Usuario registrado';
            }

            const name = [user.name, user.last_name]
                .filter(Boolean)
                .join(' ')
                .trim();

            return name || user.email || 'Usuario registrado';
        },

        getAuthorizationSummary(contract) {
            return this.getAuthorizationDefinitions()
                .map(definition => {
                    const authorizations = Array.isArray(contract[definition.key])
                        ? contract[definition.key].filter(authorization => authorization)
                        : [];

                    if (authorizations.length === 0) {
                        return null;
                    }

                    const lastAuthorization =
                        authorizations[authorizations.length - 1];

                    return {
                        ...definition,
                        authorized: true,
                        user_id: lastAuthorization.user_id,

                        users: authorizations.map(authorization =>
                            this.getAuthorizationUserName(authorization)
                        ),

                        date:
                            lastAuthorization.reviewed_at ||
                            lastAuthorization.authorized_at ||
                            lastAuthorization.created_at ||
                            ''
                    };
                })
                .filter(authorization => authorization !== null);
        },

        getAuthorizationProgress(contract) {
            const completed = this.getAuthorizationSummary(contract).filter(
                authorization => authorization.authorized
            ).length;

            console.log(completed);

            return {
                completed,
                total: 3,
                percentage: Math.round((completed / 3) * 100)
            };
        },

        shouldShowAuthorizeButton(contract) {
            if (!this.authUser) {
                return false;
            }

            const chartId = Number(
                this.authUser.organization_charts_id
            );

            const roleArrayMap = {
                1: 'user_admin',
                11: 'user_juridical',
                10: 'user_auxiliary'
            };

            const roleKey = roleArrayMap[chartId];

            if (!roleKey || !Array.isArray(contract[roleKey])) {
                return false;
            }

            return contract[roleKey].length === 0;
        },

        isExpanded(contractId) {
            return this.expandedContracts.includes(contractId);
        },

        toggleContract(contractId) {
            const position = this.expandedContracts.indexOf(contractId);

            if (position >= 0) {
                this.expandedContracts.splice(position, 1);
                return;
            }

            this.expandedContracts.push(contractId);
        },

        hasRelatedContracts(contract) {
            const parents = contract ? contract.parents_recursive : null;
            const children = contract ? contract.children_contracts : null;

            return (
                Number(contract && contract.children_contracts_count) > 0 ||
                (Array.isArray(parents) && parents.length > 0) ||
                (Array.isArray(children) && children.length > 0) ||
                Boolean(contract && contract.parent_contract_id)
            );
        },

        getRelatedContracts(contract) {
            if (Array.isArray(contract.parents_recursive)) {
                return contract.parents_recursive;
            }

            if (Array.isArray(contract.children_contracts)) {
                return contract.children_contracts;
            }

            return contract;
        },

        clearFilters() {
            this.search = createDefaultSearch();
            this.authorizationCatalogue.users_profile = [];
        },

        setContractStatus(status) {
            if (Number(this.search.status) === Number(status)) {
                return;
            }

            this.search.status = status;
        },

        getUserProfile() {
            const profile = this.search.authorization_user_id;

            this.search.user_id_authorization = '';
            this.authorizationCatalogue.users_profile = [];

            if ([1, 10, 11].includes(Number(profile))) {
                this.authorizationCatalogue.get_users_profile(profile);
            }
        },

        async list(page = 1) {
            this.load = true;

            try {
                const { data } = await request.list(
                    '/contracts',
                    page,
                    this.search
                );

                if (data) {
                    this.buys = data;
                }

                if (
                    this.search.authorization_user_id !== '' &&
                    this.search.authorization_status !== ''
                ) {
                    this.getCountContractsDepartments();
                }
            } catch (error) {
                this.errors = await this.errorNotification(error);
            } finally {
                this.load = false;
            }
        },

        async getCountContractsDepartments() {
            this.loadCount = true;

            const query = new URLSearchParams({
                authorization_user_id:
                    this.search.authorization_user_id,
                authorization_status:
                    this.search.authorization_status,
                user_id_authorization:
                    this.search.user_id_authorization || ''
            });

            try {
                const { data } = await request.get(
                    `/catalogue/count_contracts?${query.toString()}`
                );

                this.count1 = data.total_filtered;
                this.count2 = data.total_missing;
            } catch (error) {
                this.errors = await this.errorNotification(error);
            } finally {
                this.loadCount = false;
            }
        },

        showEnds(contract) {
            Event.$emit('event-show-showContractEnds', contract);
        },

        showAddendum(contractId) {
            this.editForm = false;
            Event.$emit('event-show-showContractID', contractId);
        },

        renew(contract) {
            this.editForm = true;
            Event.$emit('event-show-renewContracts', contract);
        },

        addendum(contract) {
            this.editForm = true;
            Event.$emit('event-show-renewContracts', contract, 1);
        },

        showFilesContracts(contract) {
            Event.$emit('event-show-addFilesContracts', contract);
        },

        increase(contract) {
            Event.$emit('event-show-addNewIncreasess', contract);
        },

        showNewContracts(contract = false, edit = true) {
            this.editForm = edit;
            Event.$emit('event-show-addNewContracts', contract);
        },

        showTenantsRelation(tenants) {
            Event.$emit('event-show-ContractsRelation', tenants);
        },

        changeStatus(contract) {
            Event.$emit('event-show-changeStatusContracts', contract);
        },

        currentPayments(contract) {
            Event.$emit('event-show-currentPayments', contract);
        },

        editBuy(contract = {}, edit = true) {
            this.editForm = edit;
            Event.$emit('event-show-addDepartamentUser', contract);
        },

        createFrom(contract) {
            this.editForm = true;
            Event.$emit('event-show-createFrom', contract);
        },

        createFromRenovation(contract) {
            this.editForm = true;
            Event.$emit('event-show-createFromRenovation', contract);
        },

        showPays(pay) {
            Event.$emit('event-show-tablePays', pay);
        },

        downloadRecibe(id) {
            window.open(this.globalUrlFiles + '/contracts/pdf/' + id, '_blank');
        },

        downloadMovements() {
            window.open(
                `${this.globalUrlFiles}/buildings/departments_pays`,
                '_blank'
            );
        },

        downloadExcel() {
            window.open(
                `${this.globalUrlFiles}/contract/report_excel`,
                '_blank'
            );
        },

        async deleteContract(id) {
            const result = await this.$swal({
                title: 'Eliminar contrato',
                text: 'Esta acción eliminará el contrato seleccionado.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#dc2626',
                cancelButtonColor: '#64748b',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            });

            if (!result.isConfirmed) {
                return;
            }

            try {
                const response = await request.destroy(`/contracts/${id}`);
                this.list(this.page);
                this.successNotification(response.data.message);
            } catch (error) {
                this.errors = await this.errorNotification(error);
            }
        },

        async execute_debts() {
            const result = await this.$swal({
                title: 'Generar adeudos',
                text: 'Se generarán los adeudos correspondientes.',
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#0f766e',
                cancelButtonColor: '#64748b',
                confirmButtonText: 'Generar adeudos',
                cancelButtonText: 'Cancelar'
            });

            if (!result.isConfirmed) {
                return;
            }

            try {
                const response = await request.get('/ejecutar-adeudos');
                this.list(this.page);
                this.successNotification(response.data.message);
            } catch (error) {
                this.errors = await this.errorNotification(error);
            }
        },

        async signedContract(id) {
            const result = await this.$swal({
                title: 'Firmar contrato',
                text: 'El contrato quedará registrado como firmado.',
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#2563eb',
                cancelButtonColor: '#64748b',
                confirmButtonText: 'Marcar como firmado',
                cancelButtonText: 'Cancelar'
            });

            if (!result.isConfirmed) {
                return;
            }

            try {
                const response = await request.post(`/contracts/${id}/signed`);
                this.list(this.page);
                this.successNotification(response.data.message);
            } catch (error) {
                this.errors = await this.errorNotification(error);
            }
        },

        async reviewed(contract) {
            const result = await this.$swal({
                title: 'Autorizar contrato',
                text: 'Tu autorización quedará registrada en el contrato.',
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#16a34a',
                cancelButtonColor: '#64748b',
                confirmButtonText: 'Autorizar',
                cancelButtonText: 'Cancelar'
            });

            if (!result.isConfirmed) {
                return;
            }

            try {
                const response = await request.post(
                    `/contracts_authorized?id=${contract.id}`
                );

                this.list(this.page);
                this.successNotification(response.data.message);
            } catch (error) {
                this.errors = await this.errorNotification(error);
            }
        }
    }
};
</script>

<template>
    <div class="col-12 pb-5">
        <ModalFormComponentContracts :prop_edit="editForm" />
        <ModalForm :prop_edit="editForm" />
        <ModalTablePays />
        <ModalContractEnds />
        <ModalFormCurrentPayments />
        <ModalTableContractsRelation />
        <ModalFormIncreases />
        <ModalFilesContractsComponent />
        <ModalContractEndsDetailComponent />
        <ModalContractBillingDay :visible="billingModalVisible" :contract-id="billingContractId" :can-edit="Boolean(
            authUser &&
            Number(authUser.organization_charts_id) === 1
        )" @close="closeBillingModal" @billing-updated="onBillingScheduleUpdated" />

        <div class="card contracts-module">
            <div class="card-header contracts-module__header">
                <div class="d-flex flex-wrap align-items-center justify-content-between">
                    <div class="module-title mb-2 mb-lg-0">
                        <div class="d-flex align-items-center">
                            <i class="fa-solid fa-file-contract mr-2"></i>
                            <h3 class="mb-0">Lista de Contratos</h3>
                        </div>
                        <p class="mb-0">Consulta importes, vigencias y aumentos.</p>
                    </div>

                    <div class="d-flex flex-wrap module-actions">
                        <button v-can="'add_contracts'" type="button" class="btn btn-outline-primary btn-sm"
                            @click="showNewContracts()">
                            <i class="fa-solid fa-plus mr-1"></i>
                            Nuevo contrato
                        </button>

                        <button v-can="'add_contracts'" type="button" class="btn btn-outline-secondary btn-sm"
                            @click="execute_debts">
                            <i class="fa-solid fa-money-bill-trend-up mr-1"></i>
                            Generar adeudos
                        </button>

                        <button type="button" class="btn btn-outline-success btn-sm" @click="downloadExcel">
                            <i class="fa-solid fa-file-excel mr-1"></i>
                            Excel de contratos
                        </button>

                        <button type="button" class="btn btn-outline-info btn-sm" @click="downloadMovements">
                            <i class="fa-solid fa-file-arrow-down mr-1"></i>
                            Movimientos
                        </button>
                    </div>
                </div>
            </div>

            <div class="card-body contracts-module__body">
                <section class="filters-box">
                    <div class="filters-box__title">
                        <i class="fa-solid fa-filter mr-2"></i>
                        <strong>Filtros</strong>

                        <div class="filters-box__actions ml-auto">
                            <button v-if="activeFiltersCount > 0" type="button" class="btn btn-link btn-sm p-0"
                                @click="clearFilters">
                                Limpiar filtros
                            </button>
                            <button type="button" class="btn btn-link btn-sm p-0"
                                :aria-expanded="showFilters ? 'true' : 'false'" @click="showFilters = !showFilters">
                                <i class="fa-solid mr-1" :class="showFilters ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                {{ showFilters ? 'Ocultar' : 'Mostrar' }}
                            </button>
                        </div>
                    </div>

                    <div v-show="showFilters" class="row">
                        <div class="col-sm-6 col-xl-3 mb-3 mb-xl-0">
                            <label>Búsqueda</label>
                            <div class="input-group input-group-sm">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <i class="fa-solid fa-magnifying-glass"></i>
                                    </span>
                                </div>
                                <input v-model.trim="search.search" type="search" class="form-control"
                                    placeholder="ID, cliente o propiedad" aria-label="Buscar contratos">
                            </div>
                        </div>

                        <div class="col-sm-6 col-xl-3 mb-3 mb-xl-0">
                            <label>Empresa</label>
                            <select v-model="search.company_id" class="form-control form-control-sm">
                                <option value="">Todas las empresas</option>
                                <option v-for="company in catalogue.companies_all" :key="company.id"
                                    :value="company.id">
                                    {{ company.name }}
                                </option>
                            </select>
                        </div>

                        <div class="col-sm-6 col-xl-3 mb-3 mb-xl-0">
                            <label>Propiedad</label>
                            <select v-model="search.building_id" class="form-control form-control-sm">
                                <option value="">Todas las propiedades</option>
                                <option v-for="building in catalogue.buildings" :key="building.id" :value="building.id">
                                    {{ building.name }}
                                </option>
                            </select>
                        </div>

                        <div class="col-sm-6 col-xl-3">
                            <label>Cliente</label>
                            <select v-model="search.user_id" class="form-control form-control-sm">
                                <option value="">Todos los clientes</option>
                                <option v-for="user in clientCatalogue.users_profile" :key="user.id" :value="user.id">
                                    {{ user.name }} {{ user.last_name }}
                                </option>
                            </select>
                        </div>

                    </div>

                    <div v-show="showFilters" class="row mt-3">
                        <div class="col-sm-6 col-xl-2 mb-3 mb-xl-0">
                            <label>Estatus</label>
                            <select v-model="search.status" class="form-control form-control-sm">
                                <option :value="1">Activos</option>
                                <option :value="2">Terminados</option>
                            </select>
                        </div>
                        <div class="col-sm-6 col-xl-3 mb-3 mb-xl-0">
                            <label>Situación especial</label>
                            <select v-model="search.finish" class="form-control form-control-sm">
                                <option value="">Todas las situaciones</option>
                                <option value="3">Aumento próximo (60 días)</option>
                                <option value="4">Vencido sin finalizar</option>
                                <option value="5">Falta firma</option>
                            </select>
                        </div>

                        <div v-if="search.finish" class="col-sm-6 col-xl-2 mb-3 mb-xl-0">
                            <label>Mes</label>
                            <select v-model="search.month" class="form-control form-control-sm">
                                <option value="">Todos</option>
                                <option v-for="month in months" :key="month.value" :value="month.value">
                                    {{ month.label }}
                                </option>
                            </select>
                        </div>

                        <div v-if="search.finish" class="col-sm-6 col-xl-2 mb-3 mb-xl-0">
                            <label>Año</label>
                            <select v-model="search.year" class="form-control form-control-sm">
                                <option value="">Todos</option>
                                <option v-for="year in years" :key="year" :value="year">
                                    {{ year }}
                                </option>
                            </select>
                        </div>

                    </div>

                    <!-- <div v-show="showFilters" class="payment-period-filter">
                        <span class="payment-period-filter__label">
                            Periodicidad
                        </span>
                        <label
                            v-for="period in paymentPeriods"
                            :key="period.value"
                            class="payment-period-option"
                        >
                            <input
                                v-model="search.payment_period_id"
                                type="checkbox"
                                :value="period.value"
                            >
                            <span>{{ period.label }}</span>
                        </label>
                    </div> -->

                    <div v-if="canFilterAuthorization && showFilters" class="authorization-filters">
                        <div class="row align-items-end">
                            <div class="col-sm-6 col-xl-3 mb-3 mb-xl-0">
                                <label>Perfil de autorización</label>
                                <select v-model="search.authorization_user_id" class="form-control form-control-sm"
                                    @change="getUserProfile">
                                    <option value="">Todos los perfiles</option>
                                    <option value="1">Administrador</option>
                                    <option value="10">Analista contable</option>
                                    <option value="11">Jurídico</option>
                                    <option value="100">Revisión conjunta</option>
                                </select>
                            </div>

                            <div class="col-sm-6 col-xl-3 mb-3 mb-xl-0">
                                <label>Responsable</label>
                                <select v-model="search.user_id_authorization" class="form-control form-control-sm"
                                    :disabled="!canSelectAuthorizationUser">
                                    <option value="">
                                        {{
                                            Number(search.authorization_user_id) === 100
                                                ? 'No aplica en revisión conjunta'
                                                : 'Todos los responsables'
                                        }}
                                    </option>
                                    <option v-for="user in authorizationCatalogue.users_profile" :key="user.id"
                                        :value="user.id">
                                        {{ user.name }} {{ user.last_name }}
                                    </option>
                                </select>
                            </div>

                            <div class="col-sm-6 col-xl-3 mb-3 mb-sm-0">
                                <label>Estado de autorización</label>
                                <select v-model="search.authorization_status" class="form-control form-control-sm">
                                    <option value="">Todos los estados</option>
                                    <option value="1">Autorizados</option>
                                    <option value="2">Pendientes</option>
                                </select>
                            </div>

                            <div v-if="
                                search.authorization_user_id !== '' &&
                                search.authorization_status !== ''
                            " class="col-sm-6 col-xl-3">
                                <div class="authorization-result">
                                    <span>RESUMEN</span>
                                    <strong v-if="loadCount">
                                        <i class="fa-solid fa-circle-notch fa-spin"></i>
                                    </strong>
                                    <div v-else class="authorization-result__counts">
                                        <strong>{{ count1 }}</strong>
                                        <small>resultados</small>
                                        <strong>{{ count2 }}</strong>
                                        <small>pendientes</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="row summary-row">
                    <div class="col-sm-6 col-xl-2 mb-3">
                        <div class="summary-card summary-card--total">
                            <span class="summary-card__icon">
                                <i class="fa-solid fa-file-contract"></i>
                            </span>
                            <div>
                                <span class="summary-card__label">TOTAL DE RESULTADOS</span>
                                <strong>{{ buys.total || 0 }}</strong>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6 col-xl-2 mb-3">
                        <div class="summary-card summary-card--page">
                            <span class="summary-card__icon">
                                <i class="fa-solid fa-list"></i>
                            </span>
                            <div>
                                <span class="summary-card__label">EN ESTA PÁGINA</span>
                                <strong>{{ contracts.length }}</strong>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6 col-xl-2 mb-3">
                        <div class="summary-card summary-card--increase">
                            <span class="summary-card__icon">
                                <i class="fa-solid fa-arrow-trend-up"></i>
                            </span>
                            <div>
                                <span class="summary-card__label">CON AUMENTOS EN PÁGINA</span>
                                <strong>{{ pageContractsWithIncreases }}</strong>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6 col-xl-2 mb-3">
                        <div class="summary-card summary-card--pending">
                            <span class="summary-card__icon">
                                <i class="fa-solid fa-file-signature"></i>
                            </span>
                            <div>
                                <span class="summary-card__label">SIN FIRMA EN PÁGINA</span>
                                <strong>{{ pageUnsignedContracts }}</strong>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6 col-xl-2 mb-3">
                        <div class="summary-card summary-card--expired">
                            <span class="summary-card__icon">
                                <i class="fa-solid fa-calendar-xmark"></i>
                            </span>
                            <div>
                                <span class="summary-card__label">VENCIDOS EN PÁGINA</span>
                                <strong>{{ pageExpiredContracts }}</strong>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6 col-xl-2 mb-3">
                        <div class="summary-card summary-card--authorization">
                            <span class="summary-card__icon">
                                <i class="fa-solid fa-user-check"></i>
                            </span>
                            <div>
                                <span class="summary-card__label">PENDIENTES DE AUTORIZACIÓN</span>
                                <strong>{{ pagePendingAuthorizations }}</strong>
                            </div>
                        </div>
                    </div>
                </section>

                <div class="table-responsive contracts-table-wrapper">
                    <table class="table contracts-table mb-0">
                        <thead>
                            <tr>
                                <th class="id-column">ID</th>
                                <th>PROPIEDAD / INDIVISOS</th>
                                <th>CONTRATO</th>
                                <th>VIGENCIA</th>
                                <th class="authorization-column">
                                    ESTATUS / AUTORIZACIONES
                                </th>
                                <th>RENTA / DEPÓSITO</th>
                                <th>SERVICIOS</th>
                                <th>CLIENTE</th>
                                <th>OPCIONES</th>
                            </tr>
                        </thead>

                        <tbody v-if="load">
                            <tr>
                                <td colspan="9">
                                    <div class="table-state">
                                        <i class="fa-solid fa-circle-notch fa-spin fa-2x"></i>
                                        <span>Cargando contratos...</span>
                                    </div>
                                </td>
                            </tr>

                        </tbody>

                        <tbody v-else-if="contracts.length">
                            <template v-for="contract in contracts">
                                <tr :key="contract.id" class="contract-row" :class="{
                                    'contract-row--expired':
                                        isExpiredDate(contract.end_date) &&
                                        !contract.end_all,
                                    'contract-row--finished':
                                        Number(contract.status) === 2 ||
                                        contract.end_all,
                                    'contract-row--active':
                                        Number(contract.status) === 1 &&
                                        !isExpiredDate(contract.end_date) &&
                                        !contract.end_all
                                }">
                                    <td class="id-column contract-id-cell" data-label="ID">
                                        <strong>{{ contract.id }}</strong>
                                    </td>

                                    <td class="contract-building-cell" data-label="Propiedad / Indivisos">
                                        <div class="building-name">
                                            <i class="fa-regular fa-building mr-1"></i>
                                            {{
                                                contract.building
                                                    ? contract.building.name
                                                    : 'SIN PROPIEDAD'
                                            }}
                                        </div>

                                        <div class="department-list">
                                            <span v-for="department in contract.departments || []" :key="department.id"
                                                class="department-badge">
                                                Piso {{ department.level || '-' }} /
                                                {{ department.number || '-' }}
                                            </span>

                                            <span v-if="!(contract.departments || []).length" class="text-muted">
                                                Sin indivisos
                                            </span>
                                        </div>

                                        <hr v-if="hasParentContracts(contract)">

                                        <div v-if="hasParentContracts(contract)" class="addendum-box">
                                            <div class="addendum-box__header">
                                                <span class="addendum-box__icon">
                                                    <i class="fa-solid fa-code-branch"></i>
                                                </span>

                                                <div>
                                                    <strong>Addendum</strong>
                                                    <small>
                                                        {{
                                                            getParentContractIds(contract).length === 1
                                                                ? 'Derivado de un contrato'
                                                                : 'Cadena de contratos'
                                                        }}
                                                    </small>
                                                </div>
                                            </div>

                                            <div class="addendum-box__contracts">
                                                <button v-for="parent in getParentContractIds(contract)"
                                                    :key="'parent-' + contract.id + '-' + parent" type="button"
                                                    class="parent-contract-button" :title="'Ver contrato #' + parent"
                                                    @click="showAddendum(parent)">
                                                    <i class="fa-regular fa-file-lines mr-1"></i>
                                                    #{{ parent }}
                                                </button>
                                            </div>
                                        </div>



                                    </td>

                                    <td class="contract-type-cell" data-label="Contrato">
                                        <strong class="contract-type">
                                            {{
                                                Number(contract.unique_rent) === 1
                                                    ? 'RENTA ÚNICA'
                                                    : 'POR INDIVISO'
                                            }}
                                        </strong>
                                        <span class="contract-detail-text">
                                            {{
                                                contract.payment_period
                                                    ? contract.payment_period.name
                                                    : 'Sin recurrencia'
                                            }}
                                        </span>
                                        <span v-if="contract.company" class="contract-detail-text">
                                            {{ contract.company.name }}
                                        </span>
                                    </td>

                                    <td class="date-column contract-date-cell" data-label="Vigencia">
                                        <strong v-if="contract.start_date">
                                            {{ contract.start_date | toDateTime }}
                                        </strong>
                                        <span v-else>Sin inicio</span>

                                        <span class="date-separator">al</span>

                                        <strong v-if="contract.end_date" :class="{
                                            'text-danger':
                                                isExpiredDate(contract.end_date)
                                        }">
                                            {{ contract.end_date | toDateTime }}
                                        </strong>
                                        <span v-else>Sin término</span>
                                    </td>

                                    <td class="authorization-column contract-status-cell"
                                        data-label="Estatus / Autorizaciones">
                                        <span class="status-pill" :class="getContractStatus(contract).className">
                                            <i class="fa-solid mr-1" :class="getContractStatus(contract).icon"></i>
                                            {{ getContractStatus(contract).label }}
                                        </span>



                                        <div v-if="contract.has_applied_increases || Number(contract.pending_increases_count) > 0"
                                            class="increase-summary">
                                            <small v-if="contract.has_applied_increases"
                                                class="increase-status increase-status--applied">
                                                <i class="fa-solid fa-arrow-trend-up mr-1"></i>
                                                {{ contract.applied_increases_count }}
                                                {{
                                                    Number(contract.applied_increases_count) === 1
                                                        ? 'aumento aplicado'
                                                        : 'aumentos aplicados'
                                                }}
                                            </small>

                                            <small v-if="Number(contract.pending_increases_count) > 0"
                                                class="increase-status increase-status--waiting">
                                                <i class="fa-regular fa-clock mr-1"></i>
                                                {{ contract.pending_increases_count }}
                                                {{
                                                    Number(contract.pending_increases_count) === 1
                                                        ? 'pendiente'
                                                        : 'pendientes'
                                                }}
                                            </small>
                                        </div>

                                        <hr>
                                        <small class="authorization-status" :class="{
                                            'authorization-status--complete':
                                                isFullyAuthorized(contract),
                                            'authorization-status--pending':
                                                !isFullyAuthorized(contract)
                                        }">
                                            <i class="fa-solid fa-user-check mr-1"></i>
                                            Autorizaciones
                                            {{ getAuthorizationProgress(contract).completed }}/3
                                        </small>

                                        <div class="authorization-inline-list">
                                            <div v-for="authorization in getAuthorizationSummary(contract)"
                                                :key="'inline-' + authorization.key" class="authorization-inline-item"
                                                :class="authorization.authorized
                                                    ? 'authorization-inline-item--complete'
                                                    : 'authorization-inline-item--pending'">
                                                <!-- Icono -->
                                                <span class="authorization-inline-item__icon">
                                                    <i class="fa-solid" :class="authorization.icon"></i>
                                                </span>

                                                <!-- Información -->
                                                <div class="authorization-inline-item__content">
                                                    <strong>{{ authorization.label }}</strong>

                                                    <span v-if="authorization.authorized">
                                                        {{ authorization.users.join(', ') }}
                                                    </span>

                                                    <span v-else class="authorization-inline-item__pending-text">
                                                        Pendiente
                                                    </span>
                                                </div>

                                                <!-- Acciones -->
                                                <div class="authorization-inline-item__actions">

                                                    <!-- Cancelar autorización -->
                                                    <button v-if="authorization.authorized" type="button"
                                                        class="authorization-inline-item__cancel mr-3"
                                                        title="Cancelar autorización"
                                                        @click.stop="confirmCancelAuthorization(contract, authorization)">
                                                        <i class="fa-solid fa-rotate-left"></i>
                                                        <span>Cancelar</span>
                                                    </button>

                                                    <!-- Estado -->
                                                    <i class="fa-solid authorization-inline-item__state" :class="authorization.authorized
                                                        ? 'fa-circle-check'
                                                        : 'fa-clock'"></i>

                                                </div>
                                            </div>
                                        </div>

                                    </td>

                                    <td class="money-column contract-money-cell" data-label="Renta / Depósito">
                                        <template v-if="Number(contract.unique_rent) === 1">
                                            <strong class="money-current">
                                                {{
                                                    currentAmount(
                                                        getUniqueRentRecord(contract),
                                                        'current_subtotal',
                                                        'subtotal'
                                                    ) | toCurrency
                                                }}
                                            </strong>

                                            <small v-if="
                                                getUniqueRentRecord(contract) &&
                                                amountChanged(
                                                    getUniqueRentRecord(contract).subtotal,
                                                    getUniqueRentRecord(contract).current_subtotal
                                                )
                                            " class="money-original">
                                                Inicial:
                                                {{
                                                    getUniqueRentRecord(contract).subtotal
                                                    | toCurrency
                                                }}
                                            </small>
                                        </template>

                                        <template v-else>
                                            <div v-for="department in contract.departments || []"
                                                :key="'rent-' + department.id" class="money-line">
                                                <span>
                                                    Piso {{ department.level || '-' }} /
                                                    {{ department.number || '-' }}
                                                </span>
                                                <strong>
                                                    {{
                                                        currentAmount(
                                                            department,
                                                            'current_subtotal_rent',
                                                            'subtotal_rent'
                                                        ) | toCurrency
                                                    }}
                                                </strong>
                                                <small v-if="
                                                    amountChanged(
                                                        department.subtotal_rent,
                                                        department.current_subtotal_rent
                                                    )
                                                " class="money-original">
                                                    Inicial:
                                                    {{ department.subtotal_rent | toCurrency }}
                                                </small>
                                            </div>
                                        </template>

                                        <div v-if="
                                            getContractDepositTotal(contract) > 0 ||
                                            getContractDepositOriginalTotal(contract) > 0
                                        " class="deposit-line">
                                            <span>Depósito</span>
                                            <strong>
                                                {{
                                                    getContractDepositTotal(contract)
                                                    | toCurrency
                                                }}
                                            </strong>

                                            <small v-if="amountChanged(
                                                getContractDepositOriginalTotal(contract),
                                                getContractDepositTotal(contract)
                                            )" class="money-original">
                                                Inicial:
                                                {{
                                                    getContractDepositOriginalTotal(contract)
                                                    | toCurrency
                                                }}
                                            </small>
                                        </div>
                                    </td>

                                    <td class="money-column services-column contract-services-cell"
                                        data-label="Servicios">
                                        <div v-if="getVisibleServices(contract).length">
                                            <div v-for="(service, serviceIndex) in getVisibleServices(contract)"
                                                :key="service.id || serviceIndex" class="money-line">
                                                <span>
                                                    {{ getServiceName(service) }}
                                                    <small v-if="service.department_label">
                                                        {{ service.department_label }}
                                                    </small>
                                                </span>

                                                <strong>
                                                    {{
                                                        currentAmount(
                                                            service,
                                                            'current_subtotal',
                                                            'subtotal'
                                                        ) | toCurrency
                                                    }}
                                                </strong>

                                                <small v-if="
                                                    amountChanged(
                                                        service.subtotal,
                                                        service.current_subtotal
                                                    )
                                                " class="money-original">
                                                    Inicial:
                                                    {{ service.subtotal | toCurrency }}
                                                </small>
                                            </div>
                                        </div>

                                        <span v-else class="text-muted">
                                            Sin servicios
                                        </span>

                                        <div v-if="getIncludedServices(contract).length" class="included-list">
                                            <small>Incluidos en renta:</small>
                                            <span v-for="(service, serviceIndex) in getIncludedServices(contract)"
                                                :key="'included-' + (service.id || serviceIndex)">
                                                {{ getServiceName(service) }}
                                            </span>
                                        </div>
                                    </td>

                                    <td class="contract-client-cell" data-label="Cliente">
                                        <div class="client-data">
                                            <span class="client-avatar">
                                                {{ getClientInitials(contract) }}
                                            </span>
                                            <div>
                                                <strong>{{ getClientName(contract) }}</strong>
                                                <small v-if="contract.user && contract.user.email">
                                                    {{ contract.user.email }}
                                                </small>
                                            </div>
                                        </div>
                                    </td>

                                    <td class="options-column contract-options-cell" data-label="Opciones">

                                        <div class="option-buttons">
                                            <button type="button" class="btn btn-outline-primary btn-sm"
                                                @click="showNewContracts(contract, false)">
                                                <i class="fa-solid fa-eye mr-1"></i>
                                                Ver
                                            </button>

                                            <div class="dropdown d-inline-block">
                                                <button type="button"
                                                    class="btn btn-outline-secondary btn-sm dropdown-toggle"
                                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    Opciones
                                                </button>

                                                <div class="dropdown-menu dropdown-menu-right">
                                                    <button v-if="getAuthorizationProgress(contract).completed != 3"
                                                        v-can="'edit_contracts'" type="button" class="dropdown-item"
                                                        @click="showNewContracts(contract)">
                                                        <i class="fa-solid fa-pen fa-fw mr-2"></i>
                                                        Editar
                                                    </button>
                                                    <button v-if="
                                                        Number(contract.status) === 1 &&
                                                        authUser &&
                                                        Number(authUser.organization_charts_id) === 1
                                                    " type="button" class="dropdown-item" @click="showBillingModal(contract)">
                                                        <i class="fa-regular fa-calendar-check fa-fw mr-2"></i>
                                                        Cambiar fecha de facturación
                                                    </button>

                                                    <button v-if="!contract.end_all" v-can="'edit_contracts'"
                                                        type="button" class="dropdown-item" @click="increase(contract)">
                                                        <i class="fa-solid fa-arrow-trend-up fa-fw mr-2"></i>
                                                        Registrar aumento
                                                    </button>

                                                    <button type="button" class="dropdown-item"
                                                        @click="showFilesContracts(contract)">
                                                        <i class="fa-solid fa-paperclip fa-fw mr-2"></i>
                                                        Evidencias
                                                        <span class="badge badge-secondary ml-1">
                                                            {{ contract.files_count || 0 }}
                                                        </span>
                                                    </button>

                                                    <a class="dropdown-item" v-if="contract.rules_billing.length == 0"
                                                        target="_blank" rel="noopener noreferrer" :href="globalUrlFiles +
                                                            '/generar_history/' +
                                                            contract.id
                                                            ">
                                                        <i class="fa-solid fa-clock-rotate-left fa-fw mr-2"></i>
                                                        Historial
                                                    </a>

                                                    <a class="dropdown-item" v-else target="_blank"
                                                        rel="noopener noreferrer" :href="globalUrlFiles +
                                                            '/generar_history_rules/' +
                                                            contract.id
                                                            ">
                                                        <i class="fa-solid fa-clock-rotate-left fa-fw mr-2"></i>
                                                        Historial
                                                    </a>

                                                    <!-- <button
                                                    type="button"
                                                    class="dropdown-item"
                                                    @click="downloadRecibe(contract.id)"
                                                >
                                                    <i class="fa-solid fa-file-pdf fa-fw mr-2"></i>
                                                    PDF del contrato
                                                </button> -->

                                                    <button type="button" class="dropdown-item"
                                                        @click="currentPayments(contract)">
                                                        <i class="fa-solid fa-money-check-dollar fa-fw mr-2"></i>
                                                        Pagos actuales
                                                    </button>

                                                    <button type="button" class="dropdown-item"
                                                        @click="showPays(contract)">
                                                        <i class="fa-solid fa-receipt fa-fw mr-2"></i>
                                                        Historial de pagos
                                                    </button>

                                                    <button v-if="hasRelatedContracts(contract)" type="button"
                                                        class="dropdown-item"
                                                        @click="showTenantsRelation(getRelatedContracts(contract))">
                                                        <i class="fa-solid fa-code-branch fa-fw mr-2"></i>
                                                        Contratos relacionados
                                                    </button>

                                                    <button v-if="hasNoAuthorizations(contract)"
                                                        v-can="'edit_contracts'" type="button" class="dropdown-item"
                                                        @click="editBuy(contract)">
                                                        <i class="fa-solid fa-building-user fa-fw mr-2"></i>
                                                        Editar indivisos
                                                    </button>

                                                    <div class="dropdown-divider"></div>

                                                    <button v-if="
                                                        Number(contract.signed) === 0 &&
                                                        authUser &&
                                                        [1, 11].includes(
                                                            Number(authUser.organization_charts_id)
                                                        )
                                                    " type="button" class="dropdown-item text-warning"
                                                        @click="signedContract(contract.id)">
                                                        <i class="fa-solid fa-file-signature fa-fw mr-2"></i>
                                                        Firmar contrato
                                                    </button>

                                                    <button v-if="
                                                        shouldShowAuthorizeButton(contract) &&
                                                        !contract.end_all
                                                    " type="button" class="dropdown-item text-success"
                                                        @click="reviewed(contract)">
                                                        <i class="fa-solid fa-circle-check fa-fw mr-2"></i>
                                                        Autorizar
                                                    </button>

                                                    <button v-if="!contract.end_all" v-can="'edit_contracts'"
                                                        type="button" class="dropdown-item"
                                                        @click="changeStatus(contract)">
                                                        <i class="fa-solid fa-power-off fa-fw mr-2"></i>
                                                        {{
                                                            Number(contract.status) === 1
                                                                ? 'Terminar'
                                                                : 'Activar'
                                                        }}
                                                    </button>

                                                    <button v-if="
                                                        Number(contract.children_contracts_count) === 0 &&
                                                        !contract.end_all
                                                    " v-can="'edit_contracts'" type="button" class="dropdown-item"
                                                        @click="renew(contract)">
                                                        <i class="fa-solid fa-rotate-right fa-fw mr-2"></i>
                                                        Renovar
                                                    </button>

                                                    <button v-if="
                                                        Number(contract.children_contracts_count) === 0 &&
                                                        !contract.end_all
                                                    " v-can="'edit_contracts'" type="button" class="dropdown-item"
                                                        @click="addendum(contract)">
                                                        <i class="fa-solid fa-file-circle-plus fa-fw mr-2"></i>
                                                        Addendum
                                                    </button>

                                                    <button v-if="Number(contract.children_contracts_count) > 0"
                                                        type="button" class="dropdown-item"
                                                        @click="showAddendum(contract.id)">
                                                        <i class="fa-solid fa-eye fa-fw mr-2"></i>
                                                        Ver addendum o renovación
                                                    </button>

                                                    <button v-can="'add_contracts'" type="button" class="dropdown-item"
                                                        @click="createFrom(contract)">
                                                        <i class="fa-solid fa-copy fa-fw mr-2"></i>
                                                        Crear desde este contrato
                                                    </button>

                                                    <button v-if="!contract.end_all" v-can="'add_contracts'"
                                                        type="button" class="dropdown-item"
                                                        @click="createFromRenovation(contract)">
                                                        <i class="fa-solid fa-arrows-rotate fa-fw mr-2"></i>
                                                        Crear desde renovación
                                                    </button>

                                                    <button v-if="contract.end_all" type="button" class="dropdown-item"
                                                        @click="showEnds(contract)">
                                                        <i class="fa-solid fa-file-lines fa-fw mr-2"></i>
                                                        Detalles de término
                                                    </button>

                                                    <div class="dropdown-divider"></div>

                                                    <button v-can="'deleted_contracts'" type="button"
                                                        class="dropdown-item text-danger"
                                                        @click="deleteContract(contract.id)">
                                                        <i class="fa-solid fa-trash fa-fw mr-2"></i>
                                                        Eliminar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                            </template>
                        </tbody>

                        <tbody v-else>
                            <tr>
                                <td colspan="9">
                                    <div class="table-state">
                                        <i class="fa-regular fa-folder-open fa-2x"></i>
                                        <span>No se encontraron contratos.</span>
                                        <button v-if="activeFiltersCount > 0" type="button"
                                            class="btn btn-outline-primary btn-sm mt-2" @click="clearFilters">
                                            Limpiar filtros
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div v-if="!load && buys.total > 0" class="pagination-row">
                    <small>
                        Mostrando {{ contracts.length }} de {{ buys.total }}
                    </small>

                    <pagination v-model="page" :records="buys.total" :per-page="buys.per_page" @paginate="list" />
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.contracts-module {
    overflow: hidden;
    border: 1px solid #dfe3e7;
    border-top: 2px solid #6c757d;
    border-radius: 0.75rem;
    background: #ffffff;
    box-shadow: 0 0.25rem 0.75rem rgba(33, 37, 41, 0.08);
}

.contracts-module__header {
    padding: 1.5rem 1.75rem 1rem;
    border-bottom: 1px solid #e9ecef;
    background: #ffffff;
}

.module-title h3 {
    color: #2f3337;
    font-size: 1rem;
    font-weight: 700;
}

.module-title>div>i {
    color: #343a40;
}

.module-title p {
    margin-top: 0.35rem;
    padding-left: 1.7rem;
    color: #7b838b;
    font-size: 0.75rem;
}

.module-actions {
    gap: 0.4rem;
}

.module-actions .btn,
.option-buttons .btn {
    border-radius: 50rem;
    font-weight: 600;
}

.contracts-module__body {
    padding: 1.1rem 1.75rem 1.5rem;
}

.filters-box {
    padding: 1rem;
    border: 1px solid #dfe3e7;
    border-radius: 0.45rem;
    background: #f8f9fa;
}

.filters-box__title {
    display: flex;
    align-items: center;
    margin-bottom: 0.9rem;
    color: #2f3337;
    font-size: 0.9rem;
}

.filters-box__actions {
    display: flex;
    align-items: center;
    gap: 0.9rem;
}

.filters-box label {
    display: block;
    margin-bottom: 0.35rem;
    color: #495057;
    font-size: 0.72rem;
    font-weight: 700;
}

.filters-box .form-control {
    height: 2.25rem;
    border-color: #ced4da;
    border-radius: 0.3rem;
    color: #495057;
    background: #ffffff;
    font-size: 0.78rem;
    box-shadow: none;
}

.filters-box .form-control:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.15rem rgba(0, 123, 255, 0.12);
}

.authorization-filters {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid #dee2e6;
}

.payment-period-filter {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.45rem;
    margin-top: 1rem;
    padding: 0.75rem;
    border: 1px solid #dee2e6;
    border-radius: 0.35rem;
    background: #ffffff;
}

.payment-period-filter__label {
    margin-right: 0.25rem;
    color: #495057;
    font-size: 0.7rem;
    font-weight: 700;
}

.payment-period-option {
    display: inline-flex !important;
    align-items: center;
    margin: 0 !important;
    padding: 0.25rem 0.5rem;
    border: 1px solid #dee2e6;
    border-radius: 50rem;
    color: #495057;
    background: #f8f9fa;
    cursor: pointer;
    font-size: 0.66rem !important;
    font-weight: 600 !important;
}

.payment-period-option input {
    margin-right: 0.3rem;
}

.authorization-result {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 2.25rem;
    padding: 0.35rem 0.75rem;
    border: 1px solid #b8daff;
    border-radius: 0.3rem;
    color: #004085;
    background: #cce5ff;
}

.authorization-result span {
    font-size: 0.62rem;
    font-weight: 700;
}

.authorization-result strong {
    font-size: 1rem;
}

.authorization-result__counts {
    display: grid;
    align-items: center;
    grid-template-columns: auto auto;
    gap: 0 0.3rem;
    line-height: 1;
}

.authorization-result__counts strong {
    font-size: 0.82rem;
    text-align: right;
}

.authorization-result__counts small {
    font-size: 0.58rem;
}

.summary-row {
    margin-top: 1rem;
}

.summary-card {
    display: flex;
    align-items: center;
    min-height: 4.75rem;
    padding: 0.85rem 1rem;
    border: 1px solid #dee2e6;
    border-left-width: 3px;
    border-radius: 0.45rem;
    background: #ffffff;
    box-shadow: 0 0.125rem 0.3rem rgba(33, 37, 41, 0.04);
}

.summary-card--total {
    border-left-color: #6c757d;
}

.summary-card--page {
    border-left-color: #28a745;
}

.summary-card--increase {
    border-left-color: #ffc107;
}

.summary-card--pending {
    border-left-color: #4c6ef5;
}

.summary-card--expired {
    border-left-color: #dc3545;
}

.summary-card--authorization {
    border-left-color: #17a2b8;
}

.summary-card__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 2.5rem;
    width: 2.5rem;
    height: 2.5rem;
    margin-right: 0.8rem;
    border-radius: 50%;
    color: #343a40;
    background: #f1f3f5;
}

.summary-card__label {
    display: block;
    color: #7b838b;
    font-size: 0.65rem;
    font-weight: 500;
    letter-spacing: 0.02em;
}

.summary-card strong {
    display: block;
    margin-top: 0.1rem;
    color: #25292d;
    font-size: 1.35rem;
    line-height: 1;
}

.contracts-table-wrapper {
    overflow: auto;
    max-height: 70vh;
    border: 1px solid #d9dee3;
    border-radius: 0.35rem;
    min-height: 500px;
}

.contracts-table {
    min-width: 1500px;
    color: #343a40;
    font-size: 0.72rem;
}

.contracts-table thead th {
    position: sticky;
    z-index: 2;
    top: 0;
    padding: 0.75rem 0.6rem;
    border-top: 0;
    border-right: 1px solid #d9dee3;
    border-bottom: 1px solid #cfd4d9;
    color: #495057;
    background: #f1f3f5;
    font-size: 0.65rem;
    font-weight: 700;
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
}

.contracts-table tbody td {
    padding: 0.65rem 0.6rem;
    border-top: 0;
    border-right: 1px solid #e1e5e8;
    border-bottom: 1px solid #e1e5e8;
    background: #ffffff;
    text-align: center;
    vertical-align: middle;
}

.contract-row td:first-child {
    border-left: 3px solid transparent;
}

.contract-row--active td:first-child {
    border-left-color: #28a745;
}

.contract-row--expired td:first-child {
    border-left-color: #dc3545;
}

.contract-row--expired td {
    background: #fff8f8;
}

.contract-row--finished td:first-child {
    border-left-color: #4c6ef5;
}

.contract-row--finished td {
    background: #f7f9ff;
}

.id-column {
    width: 4rem;
}

.building-name {
    color: #343a40;
    font-weight: 700;
    text-transform: uppercase;
}

.department-list {
    margin-top: 0.35rem;
}

.department-badge {
    display: inline-block;
    margin: 0.1rem;
    padding: 0.18rem 0.4rem;
    border-radius: 50rem;
    color: #495057;
    background: #e9ecef;
    font-size: 0.62rem;
}

.contract-type {
    display: block;
    font-size: 0.72rem;
}

.contract-detail-text {
    display: block;
    margin-top: 0.15rem;
    color: #6c757d;
    font-size: 0.65rem;
}

.date-column strong,
.date-column span {
    display: block;
}

.date-column strong {
    font-size: 0.68rem;
}

.date-separator {
    margin: 0.15rem 0;
    color: #adb5bd;
    font-size: 0.6rem;
}

.status-pill {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 6.5rem;
    padding: 0.22rem 0.55rem;
    border-radius: 50rem;
    font-size: 0.65rem;
    font-weight: 700;
}

.contract-status--active {
    color: #155724;
    background: #d4edda;
}

.contract-status--pending {
    color: #856404;
    background: #fff3cd;
}

.contract-status--expired {
    color: #721c24;
    background: #f8d7da;
}

.contract-status--finished {
    color: #1c3d72;
    background: #dbe7ff;
}

.authorization-status,
.increase-status {
    display: block;
    margin-top: 0.3rem;
    font-size: 0.6rem;
}

.authorization-status {
    font-weight: 700;
}

.authorization-status--complete {
    color: #218838;
}

.authorization-status--pending {
    color: #856404;
}

.authorization-column {
    min-width: 15rem;
}

.authorization-inline-list {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    width: 100%;
    margin-top: 0.45rem;
    text-align: left;
}

.authorization-inline-item {
    position: relative;
    display: flex;
    align-items: center;
    min-height: 2.25rem;
    padding: 0.3rem 1.55rem 0.3rem 0.4rem;
    border: 1px solid #dee2e6;
    border-radius: 0.3rem;
    background: #ffffff;
}

.authorization-inline-item--complete {
    border-color: #c3e6cb;
    background: #f4fbf6;
}

.authorization-inline-item--pending {
    border-color: #ffeeba;
    background: #fffdf5;
}

.authorization-inline-item__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 1.45rem;
    width: 1.45rem;
    height: 1.45rem;
    margin-right: 0.4rem;
    border-radius: 50%;
    color: #495057;
    background: #e9ecef;
    font-size: 0.55rem;
}

.authorization-inline-item>div {
    min-width: 0;
}

.authorization-inline-item>div strong,
.authorization-inline-item>div span {
    display: block;
}

.authorization-inline-item>div strong {
    color: #495057;
    font-size: 0.57rem;
    line-height: 1.15;
}

.authorization-inline-item>div span {
    overflow: hidden;
    margin-top: 0.08rem;
    color: #6c757d;
    font-size: 0.58rem;
    line-height: 1.2;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.authorization-inline-item__state {
    position: absolute;
    top: 50%;
    right: 0.5rem;
    transform: translateY(-50%);
    font-size: 0.62rem;
}

.authorization-inline-item--complete .authorization-inline-item__state {
    color: #28a745;
}

.authorization-inline-item--pending .authorization-inline-item__state {
    color: #ffc107;
}

.increase-summary {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 0.15rem;
    margin-top: 0.3rem;
}

.increase-status {
    margin-top: 0;
    font-weight: 600;
}

.increase-status--applied {
    color: #856404;
}

.increase-status--waiting {
    color: #6c757d;
}

.money-column {
    min-width: 10rem;
}

.money-current {
    display: block;
    color: #212529;
    font-size: 0.82rem;
}

.money-line {
    padding: 0.25rem 0;
    border-bottom: 1px solid #f0f1f2;
}

.money-line:last-child {
    border-bottom: 0;
}

.money-line>span,
.money-line>strong {
    display: block;
}

.money-line>span {
    color: #6c757d;
    font-size: 0.62rem;
}

.money-line>span small {
    display: block;
    color: #adb5bd;
}

.money-line>strong {
    margin-top: 0.05rem;
    color: #212529;
    font-size: 0.75rem;
}

.money-original {
    display: block;
    margin-top: 0.1rem;
    color: #868e96;
    font-size: 0.58rem;
    text-decoration: line-through;
}

.deposit-line {
    margin-top: 0.35rem;
    padding-top: 0.35rem;
    border-top: 1px solid #dee2e6;
}

.deposit-line span,
.deposit-line strong {
    display: block;
}

.deposit-line span {
    color: #6c757d;
    font-size: 0.6rem;
}

.deposit-line strong {
    color: #138496;
    font-size: 0.75rem;
}

.included-list {
    margin-top: 0.35rem;
    padding-top: 0.35rem;
    border-top: 1px dashed #ced4da;
}

.included-list small {
    display: block;
    color: #6c757d;
}

.included-list span {
    display: inline-block;
    margin: 0.1rem;
    padding: 0.15rem 0.35rem;
    border-radius: 50rem;
    color: #155724;
    background: #d4edda;
    font-size: 0.58rem;
}

.client-data {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 12rem;
    text-align: left;
}

.client-avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 2rem;
    width: 2rem;
    height: 2rem;
    margin-right: 0.55rem;
    border-radius: 50%;
    color: #ffffff;
    background: #60708a;
    font-size: 0.62rem;
    font-weight: 700;
}

.client-data strong,
.client-data small {
    display: block;
}

.client-data strong {
    max-width: 11rem;
    font-size: 0.68rem;
    text-transform: uppercase;
}

.client-data small {
    max-width: 11rem;
    overflow: hidden;
    color: #6c757d;
    font-size: 0.58rem;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.options-column {
    min-width: 11rem;
}

.expand-contract-button {
    display: block;
    margin: 0.2rem auto 0;
    padding: 0;
    color: #6c757d;
    font-size: 0.65rem;
}

.contract-detail-row>td {
    padding: 0 !important;
    border-right: 0 !important;
    background: #f8f9fa !important;
}

.contract-expanded {
    padding: 1rem 1.15rem 1.1rem;
    border-left: 3px solid #17a2b8;
    text-align: left;
}

.contract-expanded__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
}

.contract-expanded__header>div:first-child strong,
.contract-expanded__header>div:first-child small {
    display: block;
}

.contract-expanded__header>div:first-child strong {
    color: #343a40;
    font-size: 0.8rem;
}

.contract-expanded__header>div:first-child small {
    margin-top: 0.15rem;
    color: #6c757d;
    font-size: 0.62rem;
}

.authorization-progress-label {
    text-align: right;
}

.authorization-progress-label strong,
.authorization-progress-label span {
    display: block;
}

.authorization-progress-label strong {
    color: #138496;
    font-size: 1rem;
}

.authorization-progress-label span {
    color: #6c757d;
    font-size: 0.58rem;
}

.authorization-progress {
    overflow: hidden;
    height: 0.32rem;
    margin: 0.65rem 0 0.85rem;
    border-radius: 50rem;
    background: #dee2e6;
}

.authorization-progress__bar {
    height: 100%;
    border-radius: inherit;
    background: #28a745;
    transition: width 0.2s ease;
}

.authorization-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.65rem;
}

.authorization-card {
    position: relative;
    display: flex;
    align-items: center;
    min-height: 4rem;
    padding: 0.65rem 2rem 0.65rem 0.7rem;
    border: 1px solid #dee2e6;
    border-radius: 0.4rem;
    background: #ffffff;
}

.authorization-card--complete {
    border-color: #c3e6cb;
    background: #f4fbf6;
}

.authorization-card--pending {
    border-color: #ffeeba;
    background: #fffdf5;
}

.authorization-card__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 2rem;
    width: 2rem;
    height: 2rem;
    margin-right: 0.55rem;
    border-radius: 50%;
    color: #495057;
    background: #e9ecef;
}

.authorization-card>div strong,
.authorization-card>div span,
.authorization-card>div small {
    display: block;
}

.authorization-card>div strong {
    color: #343a40;
    font-size: 0.68rem;
}

.authorization-card>div span {
    margin-top: 0.1rem;
    color: #6c757d;
    font-size: 0.6rem;
}

.authorization-card>div small {
    margin-top: 0.1rem;
    color: #868e96;
    font-size: 0.55rem;
}

.authorization-card__state {
    position: absolute;
    top: 0.65rem;
    right: 0.65rem;
}

.authorization-card--complete .authorization-card__state {
    color: #28a745;
}

.authorization-card--pending .authorization-card__state {
    color: #ffc107;
}

.contract-metrics {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 0.55rem;
    margin-top: 0.75rem;
}

.contract-metrics>div {
    padding: 0.5rem 0.6rem;
    border: 1px solid #e1e5e8;
    border-radius: 0.35rem;
    background: #ffffff;
}

.contract-metrics span,
.contract-metrics strong {
    display: block;
}

.contract-metrics span {
    color: #6c757d;
    font-size: 0.58rem;
}

.contract-metrics strong {
    margin-top: 0.1rem;
    color: #212529;
    font-size: 0.72rem;
}

.contract-quick-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.4rem;
    margin-top: 0.75rem;
}

.contract-quick-actions .btn {
    border-radius: 50rem;
    font-size: 0.65rem;
    font-weight: 600;
}

.option-buttons {
    white-space: nowrap;
}

.option-buttons>.btn,
.option-buttons>.dropdown {
    margin: 0.1rem;
}

.option-buttons .btn {
    padding: 0.22rem 0.5rem;
    font-size: 0.68rem;
}

.dropdown-menu {
    min-width: 14rem;
    font-size: 0.75rem;
}

.dropdown-item {
    padding: 0.45rem 1rem;
}

.table-state {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    min-height: 12rem;
    color: #6c757d;
}

.table-state i {
    margin-bottom: 0.6rem;
}

.pagination-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 1rem;
    color: #6c757d;
}

.pagination-row ::v-deep .VuePagination__pagination {
    margin-bottom: 0;
}

@media (max-width: 767.98px) {

    .contracts-module__header,
    .contracts-module__body {
        padding-right: 1rem;
        padding-left: 1rem;
    }

    .module-actions .btn {
        margin: 0.15rem;
    }

    .pagination-row {
        align-items: flex-start;
        flex-direction: column;
    }

    .authorization-grid,
    .contract-metrics {
        grid-template-columns: 1fr;
    }

    .contract-expanded__header {
        align-items: flex-start;
    }
}

/* ============================================================
   ADDENDUM / RELACIONES
   ============================================================ */

.contract-info-column {
    min-width: 12rem;
}

.contract-main-info {
    margin-bottom: 0.55rem;
}

.addendum-box {
    margin-top: 0.55rem;
    padding: 0.55rem;
    border: 1px solid #d9e2ec;
    border-left: 3px solid #17a2b8;
    border-radius: 0.35rem;
    background: #f8fbfc;
    text-align: left;
}

.addendum-box__header {
    display: flex;
    align-items: center;
}

.addendum-box__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 1.7rem;
    width: 1.7rem;
    height: 1.7rem;
    margin-right: 0.45rem;
    border-radius: 50%;
    color: #138496;
    background: #e3f4f7;
    font-size: 0.62rem;
}

.addendum-box__header strong,
.addendum-box__header small {
    display: block;
}

.addendum-box__header strong {
    color: #343a40;
    font-size: 0.63rem;
    font-weight: 700;
}

.addendum-box__header small {
    margin-top: 0.05rem;
    color: #868e96;
    font-size: 0.55rem;
}

.addendum-box__contracts {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
    margin-top: 0.45rem;
    padding-left: 2.15rem;
}

.parent-contract-button {
    padding: 0.18rem 0.42rem;
    border: 1px solid #bee5eb;
    border-radius: 0.25rem;
    color: #117a8b;
    background: #ffffff;
    font-size: 0.58rem;
    font-weight: 600;
    cursor: pointer;
    transition:
        border-color 0.15s ease,
        background-color 0.15s ease;
}

.parent-contract-button:hover {
    border-color: #17a2b8;
    color: #0c6574;
    background: #eaf8fa;
}

.parent-contract-button:focus {
    outline: none;
    box-shadow: 0 0 0 0.15rem rgba(23, 162, 184, 0.15);
}

.authorization-inline-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.authorization-inline-item {
    display: flex;
    align-items: center;
    gap: 10px;

    padding: 10px 12px;

    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;

    transition: all 0.2s ease;
}

.authorization-inline-item:hover {
    border-color: #cbd5e1;
    box-shadow: 0 2px 6px rgba(15, 23, 42, 0.05);
}


/* ==============================
   ICONO
================================= */

.authorization-inline-item__icon {
    width: 34px;
    height: 34px;

    display: flex;
    align-items: center;
    justify-content: center;

    flex-shrink: 0;

    border-radius: 8px;

    font-size: 14px;
}


/* AUTORIZADO */

.authorization-inline-item--complete .authorization-inline-item__icon {
    background: #ecfdf5;
    color: #059669;
}


/* PENDIENTE */

.authorization-inline-item--pending .authorization-inline-item__icon {
    background: #f8fafc;
    color: #94a3b8;
}


/* ==============================
   CONTENIDO
================================= */

.authorization-inline-item__content {
    display: flex;
    flex-direction: column;

    flex: 1;
    min-width: 0;
}

.authorization-inline-item__content strong {
    font-size: 13px;
    font-weight: 600;
    color: #1e293b;
    line-height: 1.3;
}

.authorization-inline-item__content span {
    margin-top: 2px;

    font-size: 12px;
    color: #64748b;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.authorization-inline-item__pending-text {
    color: #94a3b8 !important;
}


/* ==============================
   ACCIONES
================================= */

.authorization-inline-item__actions {
    display: flex;
    align-items: center;
    gap: 8px;

    flex-shrink: 0;
}


/* CANCELAR */

.authorization-inline-item__cancel {
    display: flex;
    align-items: center;
    gap: 5px;

    padding: 5px 8px;

    border: 1px solid transparent;
    border-radius: 6px;

    background: transparent;

    color: #94a3b8;

    font-size: 11px;
    font-weight: 500;

    cursor: pointer;

    transition: all 0.15s ease;
}

.authorization-inline-item__cancel:hover {
    color: #dc2626;
    background: #fef2f2;
    border-color: #fecaca;
}

.authorization-inline-item__cancel i {
    font-size: 10px;
}


/* ==============================
   ESTADO
================================= */

.authorization-inline-item__state {
    font-size: 15px;
}

.authorization-inline-item--complete .authorization-inline-item__state {
    color: #10b981;
}

.authorization-inline-item--pending .authorization-inline-item__state {
    color: #cbd5e1;
}


/* ============================================================
   CONTRATOS - UX RESPONSIVO SIN SCROLL ANIDADO
   Mantiene toda la lógica Vue, permisos, eventos y acciones.
   ============================================================ */
.contracts-module,
.contracts-module__body {
    min-width: 0;
    max-width: 100%;
}

.contracts-table-wrapper {
    width: 100%;
    min-width: 0 !important;
    min-height: 0 !important;
    max-height: none !important;
    overflow: visible !important;
    border: 1px solid #d9dee3;
    border-radius: 8px;
    background: #ffffff;
}

.contracts-table {
    width: 100%;
    min-width: 0 !important;
    margin-bottom: 0;
    table-layout: fixed;
    border-collapse: separate;
    border-spacing: 0;
    color: #343a40;
    font-size: 0.72rem;
}

.contracts-table thead th {
    padding: 12px 8px;
    color: #495057;
    background: #f1f3f5;
    border-top: 0;
    border-right: 1px solid #d9dee3;
    border-bottom: 2px solid #d9dde1;
    font-size: 0.65rem;
    font-weight: 700;
    text-align: center;
    vertical-align: middle;
    text-transform: uppercase;
    white-space: normal;
    overflow-wrap: anywhere;
}

.contracts-table tbody td {
    padding: 11px 8px;
    background: #ffffff;
    border-top: 0;
    border-right: 1px solid #e1e5e8;
    border-bottom: 1px solid #e1e5e8;
    font-size: 0.72rem;
    line-height: 1.45;
    text-align: center;
    vertical-align: middle;
    overflow-wrap: anywhere;
}

.contracts-table .id-column {
    width: 4%;
}

.contracts-table .contract-building-cell {
    width: 15%;
}

.contracts-table .contract-type-cell {
    width: 9%;
}

.contracts-table .contract-date-cell {
    width: 9%;
}

.contracts-table .authorization-column {
    width: 18%;
}

.contracts-table .contract-money-cell {
    width: 11%;
}

.contracts-table .contract-services-cell {
    width: 11%;
}

.contracts-table .contract-client-cell {
    width: 13%;
}

.contracts-table .contract-options-cell {
    width: 10%;
}

.contracts-table .authorization-column,
.contracts-table .money-column,
.contracts-table .client-data,
.contracts-table .options-column {
    min-width: 0 !important;
}

.contracts-table .client-data {
    width: 100%;
}

.contracts-table .client-data>div,
.contracts-table .authorization-inline-item,
.contracts-table .authorization-inline-item__content {
    min-width: 0;
}

.contracts-table .client-data strong,
.contracts-table .client-data small,
.contracts-table .authorization-inline-item__content span {
    max-width: 100%;
    overflow-wrap: anywhere;
    white-space: normal;
}

.contracts-table tbody .contract-row {
    transition: transform .15s ease, box-shadow .15s ease, background-color .15s ease;
}

.contracts-table tbody .contract-row:hover td {
    background: #f8fafc;
}

.contract-row td:first-child {
    border-left: 4px solid #6c757d;
}

.contract-row--active td:first-child {
    border-left-color: #28a745;
}

.contract-row--expired td:first-child {
    border-left-color: #dc3545;
}

.contract-row--expired td {
    background: #fff8f8;
}

.contract-row--finished td:first-child {
    border-left-color: #4c6ef5;
}

.contract-row--finished td {
    background: #f7f9ff;
}

@media (max-width: 1599px) {
    .contracts-table-wrapper {
        padding: 12px;
        border: 1px solid #e2e8f0;
        background: #f5f7fa;
    }

    .contracts-table,
    .contracts-table thead,
    .contracts-table tbody {
        display: block;
        width: 100%;
    }

    .contracts-table {
        border: 0;
        background: transparent;
    }

    .contracts-table thead {
        display: none;
    }

    .contracts-table tbody .contract-row {
        display: grid;
        grid-template-columns: repeat(12, minmax(0, 1fr));
        width: 100%;
        margin-bottom: 14px;
        overflow: visible;
        background: #ffffff;
        border: 1px solid #dce3eb;
        border-radius: 10px;
        box-shadow: 0 2px 7px rgba(15, 23, 42, 0.05);
    }

    .contracts-table tbody .contract-row>td {
        display: block;
        width: auto !important;
        min-width: 0 !important;
        margin: 0;
        padding: 12px 14px !important;
        border-top: 0;
        border-right: 0;
        border-bottom: 1px solid #edf1f5;
        text-align: left !important;
        vertical-align: top;
        white-space: normal;
        overflow-wrap: anywhere;
    }

    .contracts-table tbody .contract-row>td::before {
        content: attr(data-label);
        display: block;
        margin-bottom: 6px;
        color: #64748b;
        font-size: 10px;
        font-weight: 700;
        line-height: 1.3;
        letter-spacing: .055em;
        text-transform: uppercase;
    }

    .contracts-table tbody .contract-row>.contract-id-cell {
        grid-column: 1 / -1;
        display: flex;
        align-items: center;
        gap: 10px;
        padding-top: 10px !important;
        padding-bottom: 10px !important;
        border-left: 4px solid #6c757d;
        background: #f8fafc !important;
        font-size: 14px;
    }

    .contracts-table tbody .contract-row--active>.contract-id-cell {
        border-left-color: #28a745;
    }

    .contracts-table tbody .contract-row--expired>.contract-id-cell {
        border-left-color: #dc3545;
    }

    .contracts-table tbody .contract-row--finished>.contract-id-cell {
        border-left-color: #4c6ef5;
    }

    .contracts-table tbody .contract-row>.contract-id-cell::before {
        margin-bottom: 0;
    }

    .contract-building-cell {
        grid-column: span 6;
    }

    .contract-type-cell {
        grid-column: span 3;
    }

    .contract-date-cell {
        grid-column: span 3;
    }

    .contract-status-cell {
        grid-column: 1 / -1;
        background: #fbfcfd !important;
    }

    .contract-money-cell {
        grid-column: span 4;
        background: #fbfcff !important;
    }

    .contract-services-cell {
        grid-column: span 4;
    }

    .contract-client-cell {
        grid-column: span 4;
    }

    .contract-options-cell {
        grid-column: 1 / -1;
        border-bottom: 0 !important;
        background: #f8fafc !important;
    }

    .building-name,
    .department-list,
    .money-column,
    .client-data {
        text-align: left !important;
    }

    .authorization-inline-list {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 6px;
    }

    .authorization-inline-item {
        height: 100%;
    }

    .increase-summary {
        align-items: flex-start;
        flex-direction: row;
        flex-wrap: wrap;
    }

    .client-data {
        justify-content: flex-start;
    }

    .option-buttons {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-wrap: wrap;
        gap: 6px;
        white-space: normal;
    }

    /* Estados de carga / vacío ocupando todo el ancho */
    .contracts-table tbody>tr:not(.contract-row) {
        display: block;
        width: 100%;
    }

    .contracts-table tbody>tr:not(.contract-row)>td {
        display: block;
        width: 100% !important;
        border: 0;
        background: transparent;
    }
}

@media (max-width: 991.98px) {
    .contract-building-cell {
        grid-column: 1 / -1;
    }

    .contract-type-cell,
    .contract-date-cell {
        grid-column: span 6;
    }

    .contract-money-cell,
    .contract-services-cell {
        grid-column: span 6;
    }

    .contract-client-cell {
        grid-column: 1 / -1;
    }

    .authorization-inline-list {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 767.98px) {
    .contracts-table-wrapper {
        padding: 8px;
        margin-right: 0;
        margin-left: 0;
    }

    .contracts-table tbody .contract-row {
        display: block;
        margin-bottom: 12px;
        border-radius: 8px;
    }

    .contracts-table tbody .contract-row>td {
        display: block;
        width: 100% !important;
        padding: 11px 12px !important;
    }

    .contracts-table tbody .contract-row>.contract-id-cell {
        display: flex;
        width: 100% !important;
    }

    .authorization-inline-list {
        grid-template-columns: 1fr;
    }

    .authorization-inline-item {
        padding-right: 1.8rem;
    }

    .client-data {
        min-width: 0 !important;
    }

    .option-buttons {
        justify-content: flex-start;
    }

    .option-buttons>.btn,
    .option-buttons>.dropdown {
        margin: 0;
    }

    .contract-options-cell .option-buttons>.btn {
        flex: 1 1 auto;
    }
}

@media (max-width: 575.98px) {
    .contracts-table-wrapper {
        padding: 6px;
    }

    .contracts-table tbody .contract-row>td {
        padding: 10px !important;
    }

    .client-avatar {
        flex: 0 0 34px;
        width: 34px;
        height: 34px;
    }

    .option-buttons {
        display: grid;
        grid-template-columns: 1fr 1fr;
        width: 100%;
    }

    .option-buttons>.btn,
    .option-buttons>.dropdown,
    .option-buttons>.dropdown>.btn {
        width: 100%;
    }
}
</style>
